export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID",
  "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS",
  "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK",
  "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV",
  "WI", "WY", "DC",
];

export const CA_PROVINCE_LIST = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NU", name: "Nunavut" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "YT", name: "Yukon" },
];

export const CA_PROVINCE_CODES = CA_PROVINCE_LIST.map((p) => p.code);

// US ZIP (digits + dash) or Canadian postal (A1A 1A1), auto-detected by first char
export const formatPostal = (v) => {
  const raw = (v || "").toUpperCase();
  if (/^[A-Z]/.test(raw.trimStart())) {
    const clean = raw.replace(/[^A-Z0-9]/g, "").slice(0, 6);
    return clean.length > 3 ? `${clean.slice(0, 3)} ${clean.slice(3)}` : clean;
  }
  return raw.replace(/[^0-9-]/g, "").slice(0, 10);
};
